/* eslint-disable no-unused-vars */
import { useEffect, useCallback, useMemo, useId } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { CampaignMain, RecommendationsFloatingSideBar, ErrorComponent } from 'components';
import { useParams, useLocation } from 'react-router-dom';
import { manageCampaignsAPI } from 'services/manageCampaigns.service';
import { saveCampaignServiceAPI } from 'services/saveCampaign.service';
import { creativesActions, generalActions } from 'store/actions';
import Loader from 'components/common/loader/Loader';
import { getCreativesDetails, loadCreativeAndTrackingData } from 'store/campaign/creatives';
import { campaignEnvironment } from 'constants';
import {
  addUserAgentsOSNameListField,
  putToStoreAllCampaignData,
  add_tmp_id_to_all_data_put_to_store,
  replaceBnBannerId,
  //updateRecievedTargetingLocations,
} from 'utils';
import { cloneDeep } from 'lodash-es';
import { select_current_campaign_obj } from 'store/selectors';
import { NEW_CAMP_STAB_DEFAULT_CREATIVE, NEW_CAMP_STAB_DEFAULT_TRACKING } from 'constants';

export const DirectCampaignPage = () => {
  const { cmp_id } = useParams();

  const customeId = useId();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const app = searchParams.get('app');
  const bid = searchParams.get('bid');

  const {
    data: campaignData,
    isFetching: isFetchingCampData,
    isError: isErrorCampData,
    isSuccess: isSuccessCampData,
  } = saveCampaignServiceAPI.useGetCampaignDataByIdQuery({ id: cmp_id, app, bid, env: 'direct' });

  const {
    data: creativesAndTrackingData,
    isSuccess: isSuccessCreatAdnTrack,
    isFetching: isFetchingCreatAdnTrack,
    isError: isErrorCreatAdnTrack,
  } = saveCampaignServiceAPI.useGetCreativesAndTrackingDataQuery(
    {
      cm_id: cmp_id,
      pba_id: campaignData?.currentCampaignObj?.app,
    },
    { skip: Boolean(!campaignData?.currentCampaignObj?.app) },
  );

  const {
    data: creativeListData,
    isSuccess: isSuccessCreativeList,
    isFetching: isFetchingCreativeList,
    isError: isErrorCreativeList,
  } = saveCampaignServiceAPI.useGetCreativesListQuery({
    creativesCampaignId: cmp_id,
  });

  const dispatch = useDispatch();
  const currentCampaignObj = useSelector(select_current_campaign_obj);
  const creativesTracking = useSelector(
    (state) => state?.creatives?.creativeAndTrackingData?.creativesTracking,
  );

  const newCampaignData = useMemo(() => addUserAgentsOSNameListField(campaignData), [campaignData]);

  useEffect(() => {
    if (
      isSuccessCreatAdnTrack &&
      creativesAndTrackingData &&
      creativeListData &&
      isSuccessCreativeList
    ) {
      if (creativeListData) {
        if (creativeListData.length === 0) {
          const newTmpCreativeId = customeId;
          let newCreativeListData = [];
          let newTmpCreative = cloneDeep(NEW_CAMP_STAB_DEFAULT_CREATIVE);
          newTmpCreative.bn_bannerid = newTmpCreativeId;
          newTmpCreative.tmp_id = newTmpCreativeId;
          newTmpCreative.title =
            creativesAndTrackingData?.app_name_full ||
            creativesAndTrackingData?.app_name ||
            'Add Title';
          newTmpCreative.name = 'Add Name';
          if (currentCampaignObj.reEngageGoal) {
            newTmpCreative.appDescription_existing_users = 'Add Message';
          }
          if (currentCampaignObj.acquireNewUserGoal) {
            newTmpCreative.appDescription_new_users = 'Add Message';
          }
          newTmpCreative.status = 0;
          newCreativeListData.push(newTmpCreative);
          const newTrackingforDefaultItem = cloneDeep(NEW_CAMP_STAB_DEFAULT_TRACKING);
          newTrackingforDefaultItem.tmp_id = newTmpCreativeId;
          newTrackingforDefaultItem.bn_bannerid = newTmpCreativeId;
          dispatch(creativesActions.addTrackingDataForCreative(newTrackingforDefaultItem));
          add_tmp_id_to_all_data_put_to_store(
            creativesAndTrackingData,
            newCreativeListData,
            dispatch,
          );
          return;
        }
      }
      const { newCreativeListData, newCreativesAndTrackingData } = replaceBnBannerId({
        creativeListData,
        creativesAndTrackingData,
      });
      add_tmp_id_to_all_data_put_to_store(
        newCreativesAndTrackingData,
        newCreativeListData,
        dispatch,
      );
    }
  }, [isSuccessCreatAdnTrack, creativesAndTrackingData, creativeListData, isSuccessCreativeList]);

  useEffect(() => {
    if (!isFetchingCampData && campaignData) {
      const dataToSave = cloneDeep(newCampaignData);
      dataToSave.original_cm_name = campaignData.currentCampaignObj.campaignName;
      dataToSave.currentCampaignObj.cm_id = '';
      dataToSave.currentCampaignObj.schedulerStartDate = null;
      dataToSave.currentCampaignObj.schedulerEndDate = null;

      dispatch(generalActions.setCampaignDataForID(dataToSave));
      //updateRecievedTargetingLocations(dataToSave?.selected_locations);
    }
  }, [campaignData, isFetchingCampData]);

  const loaderFlag = useMemo(() => {
    const creativeListLoader =
      (!isSuccessCreativeList && !isErrorCreativeList) || isFetchingCreativeList;
    const campaignDataLoader = (!isSuccessCampData && !isErrorCampData) || isFetchingCampData;
    const creatAdnTrackLoader =
      (!isSuccessCreatAdnTrack && !isErrorCreatAdnTrack) || isFetchingCreatAdnTrack;
    return campaignDataLoader || creatAdnTrackLoader || creativeListLoader;
  }, [
    isSuccessCampData,
    isErrorCampData,
    isFetchingCampData,
    isSuccessCreatAdnTrack,
    isFetchingCreatAdnTrack,
    isErrorCreatAdnTrack,
    isSuccessCreativeList,
    isFetchingCreativeList,
    isErrorCreativeList,
  ]);

  useEffect(() => {
    dispatch(generalActions.setCampaignEnvironment(campaignEnvironment.duplicate));
  }, []);

  return (
    <div>
      {(isErrorCampData || isErrorCreatAdnTrack || isErrorCreativeList) && <ErrorComponent />}
      {loaderFlag && <Loader.Global delay={1} />}
      {currentCampaignObj !== undefined && creativesTracking !== undefined && !loaderFlag && (
        <>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '964px 200px',
              gap: 4,
              margin: 'auto',
              marginBottom: '50px',
              width: '964px',
              gridTemplateRows: 'auto',
              gridTemplateAreas: `"main sidebar"`,
            }}
          >
            <Box sx={{ gridArea: 'main' }}>
              <CampaignMain environment={campaignEnvironment.duplicate} />
            </Box>
            <Box sx={{ gridArea: 'sidebar' }}>{/* <RecommendationsFloatingSideBar /> */}</Box>
          </Box>
        </>
      )}
    </div>
  );
};
